export default "__VITE_ASSET__Bhb8Qb_L__"